export default "__VITE_ASSET__9e462c1a__"